import i18next from 'i18next';

const SIGN_IN_APP_TRANSLATION_PREFIX = 'signin-app';

export default (key: string, options?: object) => i18next.t(`${SIGN_IN_APP_TRANSLATION_PREFIX}.${key}`, options);
